import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";

import { SortableContext, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable";
import SortableBlockRow from "./SortableBlockRow";

const BlockList = ({
  surveyData,
  setSurveyData,
  selectedBlock,
  role,
  patientId,
  expandedTrialTypes,
  handleTrialTypeDisplay,
  handleSelectBlock,
  handleBlockChange,
  areBlocksSame,
  areTrialTypesEqual,
  logUserAction,
  infoData,
  trial,
  setHasEcrfBlocksChanged,
  selectedVisit,
}) => {
  // sensors: tells dnd-kit how drag starts (mouse/touch)
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 4, // don't start drag until cursor moves 4px
      },
    })
  );

  // When user drops an item
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      // find indexes of the dragged item and the drop target
      const oldIndex = surveyData?.findIndex((b) => b.id === active.id);
      const newIndex = surveyData?.findIndex((b) => b.id === over.id);

      const reordered = arrayMove(surveyData, oldIndex, newIndex);

      setSurveyData(reordered);
      setHasEcrfBlocksChanged(true);
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={surveyData?.map((b) => b.id)} strategy={verticalListSortingStrategy}>
        {surveyData?.map((block, index) => (
          <SortableBlockRow
            key={block.id}
            block={block}
            selectedBlock={selectedBlock}
            role={role}
            patientId={patientId}
            expandedTrialTypes={expandedTrialTypes}
            handleTrialTypeDisplay={handleTrialTypeDisplay}
            handleSelectBlock={handleSelectBlock}
            handleBlockChange={handleBlockChange}
            areBlocksSame={areBlocksSame}
            areTrialTypesEqual={areTrialTypesEqual}
            logUserAction={logUserAction}
            infoData={infoData}
            trial={trial}
            surveyData={surveyData}
            selectedVisit={selectedVisit}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default BlockList;
